import React, { useState } from "react";

/** Image with graceful navy fallback if the URL fails to load. */
export default function SmartImage({ src, alt = "", label = "", className = "", ...rest }) {
  const [failed, setFailed] = useState(false);
  if (failed || !src) {
    return (
      <div className={`absolute inset-0 w-full h-full bg-[#0d1b3e] text-[#b8892b] flex flex-col items-center justify-center ${className}`} data-testid="img-fallback">
        <svg width="46" height="46" viewBox="0 0 40 40" fill="none" className="opacity-70">
          <path d="M20 4C13 4 8 9 8 16C8 24 20 36 20 36C20 36 32 24 32 16C32 9 27 4 20 4Z" stroke="#b8892b" strokeWidth="1.4"/>
          <circle cx="20" cy="16" r="4" fill="#b8892b" />
        </svg>
        {label && <div className="mt-3 text-[10px] uppercase tracking-[0.24em] opacity-70">{label}</div>}
      </div>
    );
  }
  return (
    <img
      src={src}
      alt={alt}
      loading="eager"
      onError={() => setFailed(true)}
      className={className || "absolute inset-0 w-full h-full object-cover"}
      {...rest}
    />
  );
}
